/** Theme presets and helpers. */
export { baseDark, baseLight, cssVarName, presets, resolveThemeVars, themeToCss } from './ui/themes.js'
export type { ThemePreset } from './ui/themes.js'
export { css } from './ui/styles.js'
export type { ThemeConfig, ThemePresetName, ThemeVars, Appearance } from './core/types.js'
